import { Button, Input, message, Modal, Space, Table, Typography } from 'antd';
import React, { useState } from 'react';

import { EdutainmentDetailModal } from '@/components/UI/EdutainmentDetailModal';

import { TEST_EDUTAINMENT_DETAIL } from '../../../EditEdutainmentModal/constants';
import type { EdutainmentApplication } from '../../types';
import { RELEASED_APPLICATIONS } from './constants';
import { getTableColumns } from './helpers';
import styles from './index.module.scss';

const { Text } = Typography;
const { TextArea } = Input;

export const ReleasedTable = () => {
  const [showNewsEditor, setShowNewsEditor] = useState(false);
  const [news, setNews] = useState('');
  const [openPreviewModal, setOpenPreviewModal] = useState(false);

  const openNewsEditor = (record: EdutainmentApplication) => {
    console.log('openNewsEditor:', record);
    // TODO: 邏輯待寫

    setShowNewsEditor(true);
  };

  const closeNewsEditor = () => {
    setNews('');
    setShowNewsEditor(false);
  };

  const onPreviewButtonClick = () => {
    if (!news) {
      message.error('請輸入最新消息');
      return;
    }
    setOpenPreviewModal(true);
  };

  // TODO: TEST_EDUTAINMENT_DETAIL到時候要替換成打API拿到的資料
  const edutainmentPreview = {
    ...TEST_EDUTAINMENT_DETAIL,
    refundPolicy: '',
  };

  const addNews = () => {
    console.log('確定添加最新消息：', {
      detail: edutainmentPreview,
      news,
    });
    // TODO: 這邊應該是打API去添加最新消息
  };

  const columns = getTableColumns(openNewsEditor);

  return (
    <>
      <Table
        bordered
        rowKey="_id"
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={RELEASED_APPLICATIONS}
      />

      <Modal
        open={showNewsEditor}
        onCancel={closeNewsEditor}
        destroyOnClose
        centered
        maskClosable={false}
        footer={[
          <Button key="cancel" onClick={closeNewsEditor}>
            取消
          </Button>,
          <Button key="preview" type="primary" onClick={onPreviewButtonClick}>
            預覽
          </Button>,
        ]}
      >
        <Space direction="vertical" className={styles['w-full']}>
          <Text type="secondary">最新消息</Text>
          <TextArea
            autoSize={{ minRows: 4, maxRows: 6 }}
            maxLength={100}
            showCount
            placeholder="請輸入最新消息"
            value={news}
            onChange={(event) => setNews(event.target.value)}
          />
        </Space>
      </Modal>

      <EdutainmentDetailModal
        open={openPreviewModal}
        onCancel={() => setOpenPreviewModal(false)}
        edutainment={edutainmentPreview}
        modalFooter={[
          <Button key="edit" onClick={() => setOpenPreviewModal(false)}>
            修改
          </Button>,
          <Button key="ok" type="primary" onClick={addNews}>
            確定
          </Button>,
        ]}
        news={news}
      />
    </>
  );
};
